module.exports = "<footer class=\"footer\">\r\n  <div class=\"container\">\r\n    <a class=\"logo-font\" routerLink=\"/\">atomic web app</a>\r\n    <span class=\"attribution\">\r\n      &copy; {{ today | date: 'yyyy' }}. Atomic web app project\r\n      <a href=\"https://github.com/tsukhu/angular-atomic-app\">Fork me</a>. Code licensed under MIT.\r\n    </span>\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.component.html
// module id = 25
// module chunks = 0 1